import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./Slider.css";

import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import ApiConstants from "../../../../../../utils/apiConstants";
import updatePicURL from "../../../../../../packages/updatePicUrl";
const Slider = ({ data, editable = false }) => {
  let dummyData = [
    {
      id: 1,
      imageLink: "https://gebootcamp.com/assets/img/media/dailystar.png",
    },
    {
      id: 2,
      imageLink: "https://gebootcamp.com/assets/img/media/setopati.png",
    },
    {
      id: 3,
      imageLink: "https://gebootcamp.com/assets/img/media/barakhari.png",
    },
    {
      id: 4,
      imageLink: "https://gebootcamp.com/assets/img/media/dailystar.png",
    },
    {
      id: 5,
      imageLink: "https://gebootcamp.com/assets/img/media/setopati.png",
    },
    {
      id: 6,
      imageLink: "https://gebootcamp.com/assets/img/media/barakhari.png",
    },
  ];

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 1500 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1500, min: 993 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 993, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 664, min: 0 },
      items: 1,
    },
  };
  function refreshPage() {
    window.location.reload();
  }

  const deleteHandler = async (id) => {
    let success = await axios.delete(
      `${ApiConstants.BACKEND_BASE_URL}/homePage/deleteMedia/${id}`
    );
    if (success) {
      refreshPage();
    }
  };

  return (
    // <div></div>
    <div className="carousel_div">
      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={7000}
        keyBoardControl={true}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        className="carousel"
      >
        {data
          ? data?.map((item, index) => {
            // console.log("Another one", item);
            let imgLink = updatePicURL({ inputURL: item?.imageLink ?? "" });
            return (
              <div key={index} id="item.index">
                {editable && (
                  <DeleteIcon
                    className="carousel_image_item_delete"
                    onClick={() => {
                      deleteHandler(item?._id);
                    }}
                  />
                )}
                {item?.companyLink ?
                  <a
                    href={item?.companyLink ?? "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={imgLink}
                      alt=""
                      className="carousel_image_item"
                    />
                  </a> :
                  <img
                    src={imgLink}
                    alt=""
                    className="carousel_image_item"
                  />
                }
              </div>
            );
          })
          : dummyData.map((item, idx) => {
            return (
              <div key={idx} id={item.id}>
                <img
                  src={item.imageLink}
                  alt=""
                  className="carousel_image_item"
                />
              </div>
            );
          })}
      </Carousel>
    </div>
  );
};

export default Slider;
